export default "__VITE_ASSET__By_q921n__"